import React from 'react'
import { Add, Close, ExpandMore } from '@mui/icons-material'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  FormControlLabel,
  FormGroup,
  Switch,
  TextField,
  Typography,
} from '@mui/material'
import { removeItemAtIndex, updateObjectAtIndex } from '../../../utils/array'
import Subsection from './Subsection'

const SupportSection = ({ section, setSection, removeSection }) => {
  const setOneSubsection = (newVal, index) => {
    setSection({
      ...section,
      subsections: updateObjectAtIndex(section.subsections, newVal, index),
    })
  }

  const removeSubsection = (index) => {
    setSection({
      ...section,
      subsections: removeItemAtIndex(section.subsections, index),
    })
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <TextField
          value={section.name}
          label={'Section Name'}
          onChange={(e) => setSection({ ...section, name: e.target.value })}
          sx={{ mb: 2 }}
        ></TextField>
        <Button color={'warning'} onClick={removeSection} endIcon={<Close />}>
          Remove Section
        </Button>
      </Box>

      <FormGroup>
        <FormControlLabel
          control={
            <Switch
              checked={section.generalUsersCanSee || false}
              onChange={(e) => {
                setSection({ ...section, generalUsersCanSee: e.target.checked })
              }}
            />
          }
          label='Allow general users to view this section'
        />
      </FormGroup>

      <Typography sx={{ mb: 1 }}>Subsections</Typography>
      {section.subsections.map((subsection, i) => {
        return (
          <Accordion key={i} elevation={8}>
            <AccordionSummary expandIcon={<ExpandMore />}>
              {subsection.name}
            </AccordionSummary>
            <AccordionDetails>
              <Subsection
                subsection={subsection}
                setSubsection={(val) => setOneSubsection(val, i)}
                removeSubsection={() => removeSubsection(i)}
              />
            </AccordionDetails>
          </Accordion>
        )
      })}

      <Button
        sx={{ mt: 2 }}
        onClick={() => {
          setSection({
            ...section,
            subsections: section.subsections.concat({ name: 'New subsection' }),
          })
        }}
        endIcon={<Add />}
      >
        Add a subsection
      </Button>
    </>
  )
}

export default SupportSection
